import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnBR: CultureInfo = {
  name: 'en-BR',
  displayName: 'English (Brazil)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-BR',
  parent: CultureInfoEn
};
